import { apiClient } from '@lib/api/client';
import type { Product, ProductListResponse, ProductListParams, ProductImportResponse } from '../types/product.types';

/**
 * Product Service
 * Handles product-related API calls through the BFF
 */
export const productService = {
  /**
   * Get paginated list of products
   * Automatically filtered by the selected company in the backend
   */
  async getProducts(params?: ProductListParams): Promise<ProductListResponse> {
    const queryParams = {
      page: params?.page || 1,
      limit: params?.limit || 10,
      name: params?.name,
      code: params?.code,
      category: params?.category,
      isActive: params?.isActive,
    };

    console.log('📡 getProducts - Parámetros enviados:', queryParams);

    const response = await apiClient.get<ProductListResponse>('/products', {
      params: queryParams,
    });

    console.log('📡 getProducts - Respuesta recibida:', {
      total: response.data.total,
      page: response.data.page,
      limit: response.data.limit,
      totalPages: response.data.totalPages,
      productsCount: response.data.products.length,
    });

    return response.data;
  },

  /**
   * Get product by ID
   * TODO: Implement when backend endpoint is available
   */
  async getProductById(id: string): Promise<Product> {
    const response = await apiClient.get<Product>(`/products/${id}`);
    return response.data;
  },

  /**
   * Create a new product
   * TODO: Implement when backend endpoint is available
   */
  async createProduct(product: Partial<Product>): Promise<Product> {
    try {
      console.log('🟢 productService.createProduct - Sending request:', product);
      const response = await apiClient.post<Product>('/products', product);
      console.log('🟢 productService.createProduct - Response received:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('🔴 productService.createProduct - Error caught:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        config: {
          url: error.config?.url,
          method: error.config?.method,
          baseURL: error.config?.baseURL,
        },
      });
      throw error;
    }
  },

  /**
   * Update an existing product
   * TODO: Implement when backend endpoint is available
   */
  async updateProduct(id: string, product: Partial<Product>): Promise<Product> {
    const response = await apiClient.put<Product>(`/products/${id}`, product);
    return response.data;
  },

  /**
   * Delete a product
   * TODO: Implement when backend endpoint is available
   */
  async deleteProduct(id: string): Promise<void> {
    await apiClient.delete(`/products/${id}`);
  },

  /**
   * Download Excel template for product import
   */
  async downloadTemplate(): Promise<void> {
    const response = await apiClient.get('/products/template', {
      responseType: 'blob'
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'plantilla_productos.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  /**
   * Import products from Excel file
   */
  async importProducts(file: File): Promise<ProductImportResponse> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post<ProductImportResponse>('/products/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return response.data;
  },
};
